import { List } from 'immutable';
import { once } from 'lodash';

import { localeActionCreators } from './locales';
import { composeSubscriber } from './module';

export const subscribers = List([
  composeSubscriber({
    selector: () => null, // perhaps we need an api for a subscriber that doesn't take data
    onChange: once(() => localeActionCreators.loadingLocale())
  })
]);
